import { navigate } from 'astro:transitions/client'
import { requestedServiceId, serviceRoute, vehicleEntryRoute } from '../../server/booking-flow.mjs'
import { hasSelectedVehicle, loadBooking, selectRequestedService } from './booking-state'

let activeRoot: HTMLElement | null = null
function init() {
  const root = document.querySelector<HTMLElement>('[data-service-entry]')
  if (!root || root === activeRoot) return
  activeRoot = root
  const id = requestedServiceId(new URLSearchParams(location.search))
  const state = loadBooking()
  if (!id) {
    void navigate(state && hasSelectedVehicle(state.vehicle) ? '/afspraak/services' : '/#vehicle-title', { history: 'replace' })
    return
  }
  if (!state || !hasSelectedVehicle(state.vehicle) || !selectRequestedService(state.vehicle, id)) {
    void navigate(vehicleEntryRoute(id), { history: 'replace' })
    return
  }
  void navigate(serviceRoute(id), { history: 'replace' })
}
init()
document.addEventListener('astro:page-load', init)
document.addEventListener('astro:before-swap', () => { activeRoot = null })
